import { Grid, Link } from "@mui/material";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Types } from "Types";
import Libelle from "../../../_i18n/fr.json";
import Layout from "../../../components/Layout";
import Spinner from "../../../components/spinner/Spinner";
import { ActionCreators, Selectors } from "../../../redux/Utilisateurs";
import { Token } from "../../../services/Api/swagger";
import { RouteProps } from "react-router";
import { history } from "../../../redux/configureStore";

function ActivationComptePage() {
  const dispatch = useDispatch();
  const activerCompteUtilisateur = (token: Token) => {
    dispatch(ActionCreators.activerCompteUtilisateur.request(token));
  };

  const activerCompteFetching = useSelector((state: Types.RootState) =>
    Selectors.activationCompteFetching(state),
  );
  const activerCompteError = useSelector((state: Types.RootState) =>
    Selectors.activationCompteError(state),
  );
  useEffect(() => {
    const token = new URLSearchParams(history.location.search).get("token");
    // const token = match.params.token;
    const payload = { token: token || "" };
    activerCompteUtilisateur(payload);
  }, []);

  return (
    <React.Fragment>
      <Layout title={Libelle.pageActivation.titre}>
        <Grid>
          {activerCompteFetching && <Spinner />}
          {activerCompteError && <p>{activerCompteError.message}</p>}
          {!activerCompteError && !activerCompteFetching && (
            <>
              {" "}
              <p>Félicitation, votre compte a bien été activé.</p>
              <Link href="/dossier-location/dashboard">
                Cliquez ici pour vous connecter
              </Link>
            </>
          )}
        </Grid>
      </Layout>
    </React.Fragment>
  );
}

export default ActivationComptePage;
